import { CreateGangCommand, GangsApi, UpdateGangCommand } from '@operations/app/api'
import { createApiClient } from '@operations/app/http-client'

class GangService {
  httpClient = createApiClient(GangsApi)

  async load() {
    const { data } = await createApiClient(GangsApi).get()
    return data
  }

  async update(updateGangCommand: UpdateGangCommand) {
    const { data } = await createApiClient(GangsApi).update(updateGangCommand)
    return data
  }

  async create(createGangCommand: CreateGangCommand) {
    const { data } = await createApiClient(GangsApi).create(createGangCommand)
    return data
  }

  async delete(ids: number[]) {
    const { data } = await createApiClient(GangsApi)._delete(ids)
    return data
  }
}

const gangService = new GangService()

export default gangService
